module.exports = __webpack_public_path__ + "img/2.d842e654.png";